import { Card, Divider } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { publishBinder } from "libs/analytics/binders/onboarding/publish";
import { useAnalytics } from "libs/analytics/useAnalytics";
import type { PropertyData } from "libs/codegen/property-onboarding";
import { Fragment, type FunctionComponent, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { Title } from "../Title";
import { useMetadataAtomValue } from "../metadataAtom";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { AcceptTermsAndConditions } from "./AcceptTermsAndConditions";
import { InternalUserNotification } from "./InternalUserNotification";
import { Note } from "./Note";
import { PropertyOverview } from "./PropertyOverview";
import { TaxInformationController } from "./TaxInformationController";

import "./page.css";

export const ContractPage: FunctionComponent = () => {
    const {
        taxConfigurationList,
        cmsData: {
            publish: { publish },
        },
    } = useStaticDataAtomValue();
    const { isInternalUser } = useMetadataAtomValue();
    const countryId = useWatch<PropertyData>({
        name: "country.id",
    }) as number;

    const targetTaxConfig = taxConfigurationList[countryId];

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(publishBinder);

    return (
        <VStack gap="24" pb="32">
            <Title title={publish} hideSaveAndExit />
            {isInternalUser && <InternalUserNotification />}
            <Card type="non-interactive" variant="outlined" p="16">
                <VStack gap="16">
                    <PropertyOverview />
                    {targetTaxConfig && (
                        <Fragment>
                            <Divider />
                            <TaxInformationController {...targetTaxConfig} />
                        </Fragment>
                    )}
                    <Divider />
                    <AcceptTermsAndConditions />
                </VStack>
            </Card>
            <Note />
        </VStack>
    );
};
